export default "__VITE_ASSET__90f85a4b__"